import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow
} from '@material-ui/core';
import { LabelIcon } from '../../constants/icon-definitions';
import { IList } from 'annotation-tools/utils';
import React, { FC, memo } from 'react';
import styled from 'styled-components';
import { viewTexts } from '../../constants/view-texts';
import { ILabelFromApiType } from '../../types/record/label';
import { MuiPaper } from './mui/mui-paper';
import { MuiTableRow } from './mui/mui-table-row';
import { hueToDefaultHex } from '../../functions/hue-to-hex';

const vt = viewTexts.annotationLabels;

const TableListWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
`;

const TableWrapper = styled.div`
  padding: 10px;
`;

interface Props {
  labelList: IList<ILabelFromApiType>;
}

export const AnnotationLables: FC<Props> = memo(
  ({ labelList }: Readonly<Props>) => (
    <TableListWrapper>
      <TableWrapper>
        <MuiPaper elevation={1}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell align='left'></TableCell>
                <TableCell align='left'>{vt.name}</TableCell>
                <TableCell align='right'>{vt.count}</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {labelList.map((label,idx) => (
                <MuiTableRow key={idx} hover={false}>
                  <TableCell align='center'>
                    <LabelIcon style={{color: hueToDefaultHex(label.hue)}} />
                  </TableCell>
                  <TableCell align='left'>{label.name}</TableCell>
                  <TableCell align='right'>{label.numUsedInModelAnnotation}</TableCell>
                </MuiTableRow>
              ))}
            </TableBody>
          </Table>
        </MuiPaper>
      </TableWrapper>
    </TableListWrapper>
  )
);

AnnotationLables.displayName = 'AnnotationLables';
